import { COLORS } from '~/styles/colors';

export const mainPreviewContainerStyles = {
  borderRadius: '36px',
  display: 'flex',
  alignItems: 'unset',
  flexDirection: 'column',
  color: COLORS.textMain,
  overflow: 'auto',
  margin: '12px',
  width: '100%',
  height: 'calc(100% - 30px)',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};
